export default __webpack_public_path__ + "static/media/pencil.df0b3689.svg";